import { baseUrl, keysUrl } from "@/utils";
import axios from "axios";
import crypto from "crypto";
import { getAuth, signInWithCustomToken } from 'firebase/auth';

export const getMyPrivateKey = async (userId: string | undefined) => {
  const accessToken = localStorage?.getItem("@accessToken") || "";
  try {
    if (!userId || !accessToken) throw "no-user-id-or-no-access-token";
    const res = await axios.get(`${keysUrl}v1/patient/${userId}/keys`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return res.data.key;
  } catch (error) {
    throw error;
  }
}

export const getMyPublicKey = async (userId: string | undefined) => {
  const accessToken = localStorage?.getItem("@accessToken") || "";
  try {
    if (!userId || !accessToken) throw "no-user-id-or-no-access-token";
    const res = await axios.get(`${baseUrl}api/patients/${userId}/key`);
    return res.data.key;
  } catch (error) {
    throw error
  }
}

export const setMyPrivateKey = async (userId: string | undefined, key: string) => {
  const accessToken = localStorage?.getItem("@accessToken") || "";
  try {
    if (!userId || !accessToken || !key) throw "no-user-id-or-no-access-token-or-no-key";
    const res = await axios.put(`${keysUrl}v1/patient/${userId}/keys`, { key }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return res.data;
  } catch (error) {
    throw error;
  }
}

export const setMyPublicKey = async (userId: string | undefined, key: string) => {
  const accessToken = localStorage?.getItem("@accessToken") || "";
  try {
    if (!userId || !accessToken || !key) throw "no-user-id-or-no-access-token-or-no-key";
    const res = await axios.post(`${baseUrl}api/patients/${userId}/key`, { key });
    return res.data.key;
  } catch (error) {
    console.log(" setMyPublicKey error", error);
    throw error
  }
}

export function encrypt(key: string, text: string) {
  if (!text) {
    return;
  }
  const IV = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv(
    'aes-256-gcm',
    Buffer.from(key, 'hex'),
    IV
  );

  let encrypted = cipher.update(text, 'utf8', 'hex');
  encrypted += cipher.final('hex');

  const auth_tag = cipher.getAuthTag().toString('hex');

  const payload = IV.toString('hex') + encrypted + auth_tag;

  const payload64 = Buffer.from(payload, 'hex').toString('base64');
  return payload64;
}

export function decrypt(key: string, payload64: string) {

  if (!payload64) {
    return;
  }
  const _payload = Buffer.from(payload64, 'base64').toString('hex');

  const my_iv = _payload.substr(0, 32);
  const my_encrypted = _payload.substr(32, _payload.length - 32 - 32);
  const my_auth_tag = _payload.substr(_payload.length - 32, 32);


  try {
    const decipher = crypto.createDecipheriv(
      'aes-256-gcm',
      Buffer.from(key, 'hex'),
      Buffer.from(my_iv, 'hex')
    );

    decipher.setAuthTag(Buffer.from(my_auth_tag, 'hex'));

    let decrypted = decipher.update(my_encrypted, 'hex', 'utf8');
    decrypted += decipher.final('utf8');

    return decrypted;

  } catch (error) {
    console.log(error);
  }
}

export const signInToFirebase = async (userId: string) => {
  try {
    const auth = getAuth();
    if (auth.currentUser?.uid === userId) {
      return
    }
    const token = await getFirebaseToken(userId);
    const res = await signInWithCustomToken(auth, token);
    // console.log("sign in successfully")
    return res
  } catch (error) {
    // console.log("signInToFirebase error", error)
    throw error
  }
}

export const getRecentConsultants = async () => {
  try {
    const res = await axios.get(`${baseUrl}api/consultants/recent`);
    return res.data;
  } catch (error) {
    throw error
  }
}

export const getFirebaseToken = async (userId: string) => {
  try {
    const { data } = await axios.get(`${baseUrl}v2.0/api/patient/${userId}/generate-token`);
    if (typeof data?.token === "string") {
      return data.token
    } else {
      throw ""
    }
  } catch (error) {
    throw error
  }
}

export const agoraTokenApi = async (channelName: string) => {
  try {
    const { data } = await axios.get(`${baseUrl}v2.0/api/agora/rtc-token`, { params: { channelName } });
    return data
  } catch (error) {
    throw error
  }
};